export enum MaterialQuoting {
	BreakOut = 0,
	Fast = 10,
}
